import * as React from 'react';
import intl from 'react-intl-universal';
import { find } from 'lodash';
import { LocaleProvider } from 'antd-mobile';

import { useOnMount } from '@utils/hooks';
import { setCookie, queryURL } from '@utils/index';
import { COOKIES_KEYS } from '@constants/index';
import { LOCALES_KEYS, getLocaleLoader, SUPPOER_LOCALES } from '@locales/loaders';
import PageLoading from '@components/PageLoading';

interface IProps {
    children?: React.ReactNode;
}

export default function IntlWrapper({ children }: IProps) {
    const [currentLocale, setCurrentLocale] = React.useState('');
    const [antdLocaleData, setAntdLocaleData] = React.useState<any>(undefined);

    function loadLocales() {
        const lang = queryURL('lang') || LOCALES_KEYS.ZH_CN;
        setCookie(COOKIES_KEYS.LANG, lang);

        let targetLocale = intl.determineLocale({ cookieLocaleKey: COOKIES_KEYS.LANG }) as LOCALES_KEYS;

        if (!find(SUPPOER_LOCALES, { value: targetLocale })) {
            targetLocale = LOCALES_KEYS.ZH_CN;
        }

        getLocaleLoader(targetLocale).then(res => {
            intl.init({ currentLocale: targetLocale, locales: { [targetLocale]: res.localData } }).then(() => {
                setCurrentLocale(targetLocale);
                setAntdLocaleData(res.antdLocaleData);
            });
        });
    }

    useOnMount(loadLocales);

    if (!currentLocale) {
        return <PageLoading />;
    }

    return (
        <LocaleProvider locale={antdLocaleData}>
            <React.Fragment>{children}</React.Fragment>
        </LocaleProvider>
    );
}
